import { inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { ExchangeRateService } from '@shared/services/exchange-rate.service';

@Pipe({ name: 'convertCurrency', pure: true })
export class ConvertCurrencyPipe extends CurrencyPipe implements PipeTransform {
  private exchangeRateService = inject(ExchangeRateService)
  override transform(value, currencyCode?, display?, digitsInfo?, locale?): null;
  override transform(value, currencyCode?, display?, digitsInfo?, locale?): string | null {
    if (value && value != '' && this.exchangeRateService.exchangeRate?.exchangeRate && this.exchangeRateService.exchangeRate.exchangeRate != 1) {
      value = typeof value === 'string' ? Number(value) : value
      value = value * this.exchangeRateService.exchangeRate.exchangeRate
    }
    return super.transform(value, currencyCode)?.replace(/-/g, '‑')
  }
}
